import { Font, StyleSheet } from '@react-pdf/renderer';
import ArialFont from '@assets/fonts/arial.ttf';
import IntlMessages from '@src/util/IntlMessages';
import { PDF_FONT_SIZE, PDF_FONT_FAMILY } from './reports/shared/constants';

export const PERIOD_OPTIONS = [
  { label: <IntlMessages id="work.direction.last.seven.days.filters" />, value: 7 },
  { label: <IntlMessages id="work.direction.last.fifteen.days.filters" />, value: 15 },
  { label: <IntlMessages id="work.direction.last.thirty.filters" />, value: 30 },
  { label: <IntlMessages id="work.direction.last.year.filters" />, value: 365 },
  { label: <IntlMessages id="work.direction.personalized.period.filters" />, value: null },
];

export const getTablePDFStyle = () => {
  Font.register({
    family: PDF_FONT_FAMILY,
    src: ArialFont,
  });

  return StyleSheet.create({
    page: {
      padding: 30,
      fontFamily: PDF_FONT_FAMILY,
      fontSize: PDF_FONT_SIZE.TITLE,
    },
    title: {
      fontSize: PDF_FONT_SIZE.TITLE,
      marginBottom: 10,
      textAlign: 'center',
      fontWeight: 'bold',
    },
    headerSection: {
      marginBottom: 10,
    },
    infoHeader: {
      display: 'flex',
      flexDirection: 'row',
    },
    cardReport: {
      marginBottom: 20,
    },
  });
};
